















































































































































































































































































































































































































































import { Vue } from "vue-property-decorator";
import { utils } from "@/util";
import { Individu } from "@/models/Individu";
import { TarifEventSchedulerActiviteDocument } from "@/models/TarifEventSchedulerActiviteDocument";
import { PaletteDocument } from "@/models/PaletteDocument";
import IconePresence from "@/components/icone-presence.vue";
import IconeAbsence from "@/components/icone-absence.vue";
import { Supplement } from "@/models/Supplement";
import { TarifActiviteDocument } from "@/models/TarifActiviteDocument";
import AppIcon from "@/components/app-icon.vue";
import { Autorisations } from "@/models/Autorisations";
import { mapGetters } from "vuex";
import { Pointage } from "@/models/Pointage";

export default Vue.extend({
  data() {
    return {
      listActif: [] as Array<String>,
      now: "",
      listPalette: [] as Array<PaletteDocument>,
      autorisations: [] as Array<Autorisations>,
    };
  },

  mounted() {
    this.now = utils
      .getDateFromString((this as any).getDate, "YYYY-MM-DD")
      .format("YYYYMMDD");
    this.listActif = this.pointageActif.map((pointage: any) =>
      pointage.get_id()
    );
    this.listPalette = this.palettepresence.concat(
      this.paletteabsence
    ) as Array<PaletteDocument>;

    this.autorisations = this.enfant.getListeAutorisations();
  },
  components: { IconePresence, IconeAbsence, AppIcon },
  props: {
    enfant: {
      type: Object,
    },
    tempsAccueil: {
      type: Array,
    },
    pointageActif: {
      type: Array,
      default: () => [],
    },
    pointagesPrevi: {
      type: Array,
      default: () => [],
    },
    palettepresence: {
      type: Array,
      default: () => [],
    },
    paletteabsence: {
      type: Array,
      default: () => [],
    },
    listsupplements: {
      type: Array,
      default: () => [],
    },
    supplementsactifs: {
      type: Array,
      default: () => [],
    },
    tempsAccueilActif: {
      type: Array,
      default: () => [],
    },
    currentActivite: {
      type: Number,
    },
    listSupplementsPrevi: {
      type: Array,
      default: () => [],
    },
    currentEtablissement: {
      type: Object,
    },
    autori: {
      type: Number,
      default: -2,
    },
  },
  computed: {
    tempsAC() {
      return this.tempsAccueil.filter(
        (temps: any) =>
          temps.resource_id === "AC" &&
          this.tempsAccueilActif.includes(temps.id)
      );
    },
    tempsTS() {
      return this.tempsAccueil.filter(
        (temps: any) =>
          temps.resource_id === "TS" &&
          this.tempsAccueilActif.includes(temps.id)
      );
    },
    ...mapGetters("activites", ["getDate", "getIsDateDiff"]),
  },
  methods: {
    affichageEdition(id: number) {
      let autorisations: Array<Autorisations> = this.autorisations;
      let auto = autorisations.find(
        (item: Autorisations) =>
          item.getTypeautorisation_id() === id && item.isMobi()
      );
      if (typeof auto === "undefined") {
        return 0;
      } else {
        return auto.getAffichageedition();
      }
    },
    getRegimSrc() {
      if (
        this.enfant
          .getRegimeAlimentaireIndividu()
          .getVieQuoRegimeAli()
          .getType_regime() === "Autre"
      )
        return "/assets/information/regime/REG_ALIM_AUTRE_LISTE_NOM.svg";
      if (
        this.enfant
          .getRegimeAlimentaireIndividu()
          .getVieQuoRegimeAli()
          .getType_regime() === "Sans porc"
      )
        return "/assets/information/regime/REG_ALIM_SANS_PORC.svg";
      else if (
        this.enfant
          .getRegimeAlimentaireIndividu()
          .getVieQuoRegimeAli()
          .getType_regime() === "Sans viande"
      )
        return "/assets/information/regime/REG_ALIM_SANS_VIANDE.svg";
      else if (
        this.enfant
          .getRegimeAlimentaireIndividu()
          .getVieQuoRegimeAli()
          .getType_regime() === "Végétarien"
      )
        return "/assets/information/regime/REG_ALIM_VEGETARIEN.svg";
      else if (
        this.enfant
          .getRegimeAlimentaireIndividu()
          .getVieQuoRegimeAli()
          .getType_regime() === "Sans gluten"
      )
        return "/assets/information/regime/REG_ALIM_SANS_GLUTEN.svg";
      else if (
        this.enfant
          .getRegimeAlimentaireIndividu()
          .getVieQuoRegimeAli()
          .getType_regime() === "PAI"
      )
        return "/assets/information/regime/REG_ALIM_PAI.svg";
      else if (
        this.enfant
          .getRegimeAlimentaireIndividu()
          .getVieQuoRegimeAli()
          .getType_regime() === "Sans régime"
      )
        return "/assets/information/regime/REG_ALIM_DEFAUT_STANDARD.svg";
      else if (
        this.enfant
          .getRegimeAlimentaireIndividu()
          .getVieQuoRegimeAli()
          .getType_regime() === "Sans poisson"
      )
        return "/assets/information/regime/REG_ALIM_SANS_POISSON.svg";
      else return "/assets/information/regime/REG_ALIM_AUTRE_LISTE_NOM.svg";
    },
    findSupplementActif(
      supplement: TarifActiviteDocument,
      enfant: Individu
    ): any {
      return this.supplementsactifs.find(
        (item: any) =>
          item._id ===
          "supplementAN" +
            this.now +
            this.currentActivite +
            +supplement.getId() +
            enfant.getId()
      );
    },

    getPaletteFromIndTemps(
      enfant: Individu,
      temps: TarifEventSchedulerActiviteDocument
    ): PaletteDocument {
      let pointage: any = this.pointageActif.find(
        (pointage: any) =>
          pointage.get_id() ===
            "pointageAN" +
              this.now +
              this.currentActivite +
              temps.getFriseElement_id() +
              enfant.getId() ||
          pointage.get_id() ===
            "pointageAN" +
              this.now +
              this.currentActivite +
              temps.getTempsTarif_id() +
              enfant.getId()
      );
      let palette: any = this.listPalette.find(
        (palette) => palette.getId() === pointage.getPaletteId()
      );
      if (typeof palette === "undefined") return new PaletteDocument({});
      else return palette;
    },

    hasReservation(
      enfant: Individu,
      temps: TarifEventSchedulerActiviteDocument
    ) {
      return this.pointagesPrevi.find(
        (item: any) =>
          item.elementfrise_id === temps.getFriseElement_id() &&
          item.individu_id === enfant.getId()
      );
    },
    hasReservationTS(
      enfant: Individu,
      temps: TarifEventSchedulerActiviteDocument
    ) {
      return this.pointagesPrevi.find(
        (item: any) =>
          item.tariftempssupplactivite_id === temps.getTempsTarif_id() &&
          item.individu_id === enfant.getId()
      );
    },

    getHeureDepartRes(
      enfant: Individu,
      temps: TarifEventSchedulerActiviteDocument
    ) {
      let reservation = this.hasReservation(enfant, temps) as any;
      return typeof reservation !== "undefined"
        ? reservation.heure_depart
        : "__:__";
    },
    getHeureArriveRes(
      enfant: Individu,
      temps: TarifEventSchedulerActiviteDocument
    ) {
      let reservation = this.hasReservation(enfant, temps) as any;
      return typeof reservation !== "undefined"
        ? reservation.heure_arrive
        : "__:__";
    },
    findPointage(enfant: Individu, temps: TarifEventSchedulerActiviteDocument) {
      let pointage = this.pointageActif as Array<Pointage>;
      return pointage.find(
        (item: any) =>
          item.elementFriseId === temps.getFriseElement_id() &&
          item.idIndividu === enfant.getId()
      );
    },
    findPointageArrivee(
      enfant: Individu,
      temps: TarifEventSchedulerActiviteDocument
    ) {
      let pointage = this.pointageActif as Array<Pointage>;
      return pointage.find(
        (item: any) =>
          item.elementFriseId === temps.getFriseElement_id() &&
          item.idIndividu === enfant.getId() &&
          item.tempsDebut !== ""
      );
    },
    findPointageDepart(
      enfant: Individu,
      temps: TarifEventSchedulerActiviteDocument
    ) {
      return this.pointageActif.find(
        (item: any) =>
          item.elementFriseId === temps.getFriseElement_id() &&
          item.idIndividu === enfant.getId() &&
          item.getTempsFin() !== ""
      );
    },
    findPointageTS(
      enfant: Individu,
      temps: TarifEventSchedulerActiviteDocument
    ) {
      return this.pointageActif.find(
        (item: any) =>
          item.tempsSupplementaireId === temps.getTempsTarif_id() &&
          item.idIndividu === enfant.getId()
      );
    },
    allowPointageDepart(
      enfant: Individu,
      temps: TarifEventSchedulerActiviteDocument
    ) {
      let response = false;
      this.pointageActif.forEach((pointage: any) => {
        if (
          pointage.idIndividu === enfant.getId() &&
          pointage.tempsDebut !== "" &&
          pointage.tempsFin === "" &&
          utils
            .getDateFromString(pointage.tempsDebut, "YYYY-MM-DD HH:mm:ss")
            .format("YYYY-MM-DD HH:mm:ss") <=
            utils
              .getDateFromString(temps.getEnd_date(), "YYYY-MM-DD HH:mm:ss")
              .format("YYYY-MM-DD HH:mm:ss")
        )
          response = true;
        else if (
          pointage.idIndividu === enfant.getId() &&
          pointage.tempsFin !== "" &&
          pointage.tempsDebut === "" &&
          utils
            .getDateFromString(pointage.tempsDebut, "YYYY-MM-DD HH:mm:ss")
            .format("YYYY-MM-DD HH:mm:ss") >
            utils
              .getDateFromString(temps.getStart_date(), "YYYY-MM-DD HH:mm:ss")
              .format("YYYY-MM-DD HH:mm:ss")
        )
          response = false;
      });
      return response;
    },
    allowPointageArrivee(
      enfant: Individu,
      temps: TarifEventSchedulerActiviteDocument
    ) {
      let response = true;
      this.pointageActif.forEach((pointage: any) => {
        if (
          pointage.idIndividu === enfant.getId() &&
          utils
            .getDateFromString(pointage.tempsDebut, "YYYY-MM-DD HH:mm:ss")
            .format("YYYY-MM-DD HH:mm:ss") <
            utils
              .getDateFromString(temps.getStart_date(), "YYYY-MM-DD HH:mm:ss")
              .format("YYYY-MM-DD HH:mm:ss") &&
          pointage.tempsFin === ""
        )
          response = false;
        else if (
          pointage.idIndividu === enfant.getId() &&
          pointage.tempsFin !== "" &&
          pointage.tempsDebut === "" &&
          utils
            .getDateFromString(pointage.tempsFin, "YYYY-MM-DD HH:mm:ss")
            .format("YYYY-MM-DD HH:mm:ss") <=
            utils
              .getDateFromString(temps.getStart_date(), "YYYY-MM-DD HH:mm:ss")
              .format("YYYY-MM-DD HH:mm:ss")
        )
          response = true;
      });
      return response;
    },
    selectImgSupplements(supplement: TarifActiviteDocument, enfant: Individu) {
      if (
        this.listSupplementsPrevi.some(
          (previ: any) =>
            enfant.getId() === previ.individu_id &&
            supplement.getId() === previ.supplement_id &&
            previ.checked
        )
      ) {
        return require(`@/assets/pointage/RESERVATION_GRILLE_POINTAGE.svg`);
      } else {
        return require(`@/assets/pointage/PAS_RESERVE_GRILLE_POINTAGE.svg`);
      }
    },
    selectImgSupplementsAuto(
      supplement: TarifActiviteDocument,
      enfant: Individu
    ) {
      if (
        supplement.getElementfrise_id().length > 1 &&
        supplement.getPlageetou() === "ET"
      ) {
        let conditionActif = supplement
          .getElementfrise_id()
          .every((friseId: number) =>
            this.pointageActif.some(
              (point: any) =>
                point.get_id() ===
                  "pointageAN" +
                    this.now +
                    this.currentActivite +
                    friseId +
                    enfant.getId() &&
                this.palettepresence.some(
                  (pal: any) => pal.getId() === point.getPaletteId()
                ) &&
                point.tempsFin !== ""
            )
          );
        if (conditionActif) {
          return require(`@/assets/pointage/PRESENCE_GRILLE_POINTAGE.svg`);
        } else {
          let conditionPrevi = supplement
            .getElementfrise_id()
            .every((friseId: number) =>
              this.pointagesPrevi.some(
                (pointPrevi: any) =>
                  pointPrevi.elementfrise_id === friseId &&
                  pointPrevi.individu_id === enfant.getId()
              )
            );
          if (conditionPrevi) {
            return require(`@/assets/pointage/RESERVATION_GRILLE_POINTAGE.svg`);
          } else {
            return require(`@/assets/pointage/PAS_RESERVE_GRILLE_POINTAGE.svg`);
          }
        }
      } else {
        if (
          supplement.getElementfrise_id().length > 1 &&
          supplement.getPlageetou() === "OU"
        ) {
          let conditionActif = supplement
            .getElementfrise_id()
            .some((friseId: number) =>
              this.pointageActif.some(
                (point: any) =>
                  point.get_id() ===
                    "pointageAN" +
                      this.now +
                      this.currentActivite +
                      friseId +
                      enfant.getId() &&
                  this.palettepresence.some(
                    (pal: any) => pal.getId() === point.getPaletteId()
                  ) &&
                  point.tempsFin !== ""
              )
            );
          if (conditionActif) {
            return require(`@/assets/pointage/PRESENCE_GRILLE_POINTAGE.svg`);
          } else {
            let conditionPrevi = supplement
              .getElementfrise_id()
              .some((friseId: number) =>
                this.pointagesPrevi.some(
                  (pointPrevi: any) =>
                    pointPrevi.elementfrise_id === friseId &&
                    pointPrevi.individu_id === enfant.getId()
                )
              );
            if (conditionPrevi) {
              return require(`@/assets/pointage/RESERVATION_GRILLE_POINTAGE.svg`);
            } else {
              return require(`@/assets/pointage/PAS_RESERVE_GRILLE_POINTAGE.svg`);
            }
          }
        } else {
          if (
            this.pointageActif.some(
              (point: any) =>
                point.get_id() ===
                  "pointageAN" +
                    this.now +
                    this.currentActivite +
                    supplement.getElementfrise_id()[0] +
                    enfant.getId() &&
                this.palettepresence.some(
                  (pal: any) => pal.getId() === point.getPaletteId()
                ) &&
                point.tempsFin !== ""
            )
          ) {
            return require(`@/assets/pointage/PRESENCE_GRILLE_POINTAGE.svg`);
          } else {
            if (
              this.pointagesPrevi.some(
                (pointPrevi: any) =>
                  pointPrevi.elementfrise_id ===
                    supplement.getElementfrise_id()[0] &&
                  pointPrevi.individu_id === enfant.getId()
              )
            ) {
              return require(`@/assets/pointage/RESERVATION_GRILLE_POINTAGE.svg`);
            } else {
              return require(`@/assets/pointage/PAS_RESERVE_GRILLE_POINTAGE.svg`);
            }
          }
        }
      }
    },
    pointerArrivee(
      enfant: Individu,
      temps: TarifEventSchedulerActiviteDocument
    ) {
      if (!this.hasPointageAfter(enfant, temps))
        this.$emit("pointerArrivee", [temps, enfant]);
      else
        alert(
          "Toute modification est impossible, des créneaux ultérieurs sont pointés !"
        );
    },
    pointerDepart(
      enfant: Individu,
      temps: TarifEventSchedulerActiviteDocument
    ) {
      if (!this.hasPointageAfter(enfant, temps))
        this.$emit("pointerDepart", [temps, enfant]);
      else
        alert(
          "Toute modification est impossible, des créneaux ultérieurs sont pointés !"
        );
    },
    pointerTS(enfant: Individu, temps: TarifEventSchedulerActiviteDocument) {
      this.$emit("pointerTS", [temps, enfant]);
    },
    pointerSupplement(supplement: Supplement, enfant: Individu) {
      this.$emit("pointer-supplement", [supplement, enfant]);
    },
    removePointageTS(
      enfant: Individu,
      temps: TarifEventSchedulerActiviteDocument
    ) {
      this.$emit("removePointageTS", this.findPointageTS(enfant, temps));
    },
    removeSupplement(suppActif: Supplement) {
      this.$emit("remove-supplement", suppActif);
    },
    hasPuce(individu: Individu) {
      return this.pointageActif.find(
        (item: any) =>
          item.idIndividu === individu.getId() && item.getTempsFin() === ""
      );
    },
    hasPointageAfter(
      enfant: Individu,
      temps: TarifEventSchedulerActiviteDocument
    ) {
      let pointage = this.pointageActif as Array<Pointage>;
      return pointage.some(
        (item: any) =>
          item.elementFriseId !== temps.getFriseElement_id() &&
          item.idIndividu === enfant.getId() &&
          item.tempsDebut > temps.getStart_date() &&
          !item.tempsSupplementaireId &&
          item.tempsSupplementaireIntitule !== "Tmps SUPP"
      );
    },
    showModal(
      enfant: Individu,
      temps: TarifEventSchedulerActiviteDocument,
      type: string
    ) {
      if (!this.hasPointageAfter(enfant, temps)) {
        if (type === "arrivée")
          this.$emit("show-modal", [
            this.findPointageArrivee(enfant, temps) as Pointage,
            (
              this.findPointageArrivee(enfant, temps) as Pointage
            ).getTempsDebut(),
            "arrivée",
            enfant.getDisplayName(),
            temps,
          ]);
        else
          this.$emit("show-modal", [
            this.findPointage(enfant, temps) as Pointage,
            (this.findPointage(enfant, temps) as Pointage).getTempsFin(),
            type,
            enfant.getDisplayName(),
            temps,
          ]);
      } else
        alert(
          "Toute modification est impossible, des créneaux ultérieurs sont pointés !"
        );
    },
  },
  filters: {
    onlyDate: function (value: string) {
      return utils
        .getDateFromString(value, "YYYY-MM-DD HH:mm:ss")
        .format("DD-MM-YYYY");
    },
    onlyTime: function (temps: string) {
      return utils
        .getDateFromString(temps, "YYYY-MM-DD HH:mm:ss")
        .format("HH:mm");
    },
    formatTime(temps: string) {
      return utils.getDateFromString(temps, "HH:mm:ss").format("HH:mm");
    },
  },
  watch: {
    pointageActif(newVal: Array<Pointage>, oldVal: Array<Pointage>) {
      this.listActif = newVal.map((pointage: any) => pointage.get_id());
    },
    getDate(newVal: string, oldVal: string) {
      this.now = utils
        .getDateFromString(newVal, "YYYY-MM-DD")
        .format("YYYYMMDD");
    },
  },
});
